import script from "./ClientsPanelListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientsPanelListItem.vue?vue&type=script&setup=true&lang=ts"

import "./ClientsPanelListItem.vue?vue&type=style&index=0&id=f8db9c5a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8db9c5a"]])

export default __exports__